import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import velocity from 'velocity-animate';

const log = debug('FrontPageTeaser');

class FrontPageTeaser extends BaseComponent {
	constructor(element) {
		super(element);

		this.extraTextLinkEvent = this.extraTextLinHandler.bind(this);

		this.initialize();
	}

	eventListeners() {
		this.dom.extraTextLink.addEventListener('click', this.extraTextLinkEvent, false);
	}

	extraTextLinHandler(event) {
		event.preventDefault();

		if (this.dom.extraTextLink.classList.contains('is-open')) {
			this.hideExtraText();
		}
		else {
			this.showExtraText();
		}
		
		this.dom.extraTextLink.classList.toggle('is-open');
	}

	/**
	 * @returns {Object} settings
	 */
	getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	hideExtraText() {
		velocity(this.dom.extraText, 'fadeOut', {
			duration: 200	
		});

		this.dom.extraTextLink.innerHTML = this.settings.buttonOpenText;
}

	initialize() {
		this.getSettings();

		this.initDomCache();
		this.setup();
		this.eventListeners();
	}

	setup() {
		const extraTextContent = this.dom.extraText.innerHTML.trim();

		if (!extraTextContent) {
			this.dom.extraTextWrapper.style.display = 'none';
		}
	}

	showExtraText() {
		velocity(this.dom.extraText, 'fadeIn', {
			duration: 475
		});

		velocity(this.dom.extraText, 'scroll', {
			duration: 700,
			offset: '-40'
		});

		this.dom.extraTextLink.innerHTML = this.settings.buttonCloseText;
	}
}	

export default FrontPageTeaser;
